import { Combobox, ComboboxInput, ComboboxPopupContainer } from "@angular/aria/combobox";
import { Listbox, Option } from "@angular/aria/listbox";
import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Kooperationspartner } from "../../../Api/DcoApi/Kooperationspartner";
import { SearchAndSelectDropDownBase } from "./SearchAndSelectDropDownBase";
import { OverlayModule } from '@angular/cdk/overlay';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';
import {  User } from "../../../Api/DcoApi/Client/RestClient";

@Component({
  imports: [
    Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'KooperationspartnerSelect',
  templateUrl: './KooperationspartnerSelect.html',
  standalone: true,
  styleUrl: './KooperationspartnerSelect.css'
})
export class KooperationspartnerSelect extends SearchAndSelectDropDownBase<Kooperationspartner> {
  public ApiUser = User;
  constructor() {
    super();

  }

  override formatter: (obj: Kooperationspartner) => string = obj => `${obj.name} ${obj.ik}`;
  protected override LoadData(): Promise<Kooperationspartner[]> {
    return this.Client.Get<Kooperationspartner[]>('/Backend/Api/V2/Kooperationspartner')
  }
  protected override Serach(querry: string): Kooperationspartner[] {
    return this.Data.filter(g => querry == '' || (g.name?.toLowerCase().includes(querry?.toLowerCase()) || g.ik?.toLowerCase().includes(querry?.toLowerCase())));
  }

}
